// extracted by mini-css-extract-plugin
export default {"wrap":"suggest_wrap__HFMUB","ul":"suggest_ul__ceXUU","li":"suggest_li__uQ+3Z","selected":"suggest_selected__PDXfM","btn":"suggest_btn__c93zt"};